import { type ICompanyUserMembershipsQuery } from 'application/querySchemas/ICompanyUserMembershipsQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import {
    type ICompanyUserMembershipsClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanyUserMembershipsClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class CompanyUserMembershipsQuery implements ICompanyUserMembershipsQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyUserMembershipsClient')
        public readonly companyUserMembershipsClient: ICompanyUserMembershipsClient,
    ) {}

    public async fetch(): Promise<IGetResponse['data']> {
        const { data, message } = await this.companyUserMembershipsClient.get({
            token: this.companyUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
